import React from 'react';
import { ShareBar } from '@/routes/console/_authenticated/_layout/campaigns/$publicId/_layout/ab-testing/_layout/-features/share-bar';
export const ResultsTable = ({ results, itemName }) => {
    const rankLabel = (idx) => {
        if (idx === 0)
            return '🥇';
        if (idx === 1)
            return '🥈';
        if (idx === 2)
            return '🥉';
        return String(idx + 1);
    };
    return (<div className="rounded-md border overflow-hidden">
            <div className="overflow-x-auto">
                <table className="min-w-160 w-full text-sm">
                    <thead className="bg-muted/40">
                        <tr>
                            <th className="px-3 py-2 text-left font-medium w-12">#</th>
                            <th className="px-3 py-2 text-left font-medium">{itemName}</th>
                            <th className="px-3 py-2 text-right font-medium w-24">Scans</th>
                            <th className="px-3 py-2 text-right font-medium w-44">Share</th>
                        </tr>
                    </thead>
                    <tbody>
                        {results.map((r, idx) => (<tr key={`${r.publicId}-${idx}`} className={`border-t ${idx === 0 ? 'bg-muted/30' : ''}`}>
                                <td className="px-3 py-2 text-muted-foreground">{rankLabel(idx)}</td>
                                <td className="px-3 py-2">
                                    <div className="font-medium truncate">
                                        {r.label} · {r.publicId}
                                    </div>
                                    <div className="text-xs text-muted-foreground">
                                        {r.uniqueVisitors} unique visitors
                                    </div>
                                </td>
                                <td className="px-3 py-2 text-right tabular-nums">{r.scans}</td>
                                <td className="px-3 py-2">
                                    <ShareBar share={r.share} rank={idx}/>
                                </td>
                            </tr>))}
                    </tbody>
                </table>
            </div>
        </div>);
};
ResultsTable.displayName = 'ResultsTable';
